import { createSlice } from '@reduxjs/toolkit';

import { RegistrationState, SetMemberStatusPayload, SetProgrammesPayload } from './registration.types';

export const initialState: RegistrationState = {
  programmes: undefined,
  memberStatus: undefined
};

const RegistrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    setProgrammes: (state, action: SetProgrammesPayload) => {
      state.programmes = action.payload;
    },
    setMemberStatus: (state, action: SetMemberStatusPayload) => {
      state.memberStatus = action.payload;
    }
  }
});

export const { setProgrammes, setMemberStatus } = RegistrationSlice.actions;

export default RegistrationSlice.reducer;
